/**
 * Theme toggle (APP-001 §16).
 *
 * Cycles system → light → dark. Theme is UI state only.
 */
import { IconButton } from '@/components/ui/icon-button';
import { Monitor, Moon, Sun } from '@/components/icons';
import { useTheme } from '@/components/theme/ThemeProvider';
import { track } from '@/lib/analytics';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const next = theme === 'system' ? 'light' : theme === 'light' ? 'dark' : 'system';
  const Icon = theme === 'system' ? Monitor : theme === 'light' ? Sun : Moon;
  const label = `Theme: ${theme}. Activate to switch to ${next}.`;
  return (
    <IconButton
      label={label}
      variant="ghost"
      onClick={() => {
        setTheme(next);
        track({ event: 'theme_changed', theme: next });
      }}
    >
      <Icon className="h-4 w-4" />
    </IconButton>
  );
}
